import { Box } from "@chakra-ui/react";
import { Modal } from "antd";
import FormModalProcessarArquivos from "./FormModalProcessarArquivos/index";

interface ModalProcessarArquivosProps {
  visible: boolean;
  onClose: () => any;
  onSuccess?: () => any;
}

export default function ModalProcessarArquivos({
  visible,
  onClose,
  onSuccess,
}: ModalProcessarArquivosProps) {
  return (
    <Modal
      centered
      destroyOnClose
      visible={visible}
      footer={null}
      onCancel={onClose}
      width="700px"
    >
      <Box>
        <FormModalProcessarArquivos
          onClose={onClose}
          visible={visible}
          onSuccess={onSuccess}
        />
      </Box>
    </Modal>
  );
}
